import { jsx, jsxs } from "react/jsx-runtime";
import { Slot, Slottable } from "@radix-ui/react-slot";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { aVariants } from "./A.variants.js";
const iconSizes = {
    sm: '20',
    md: '20',
    lg: '24',
    xl: '24'
};
const A_A = /*#__PURE__*/ forwardRef(function({ asChild, children, className, iconLeft, iconRight, disabled, ...props }, ref) {
    const { buttonSlot, wrapperSlot, textSlot, iconSlot } = aVariants({
        ...props,
        disabled
    });
    const classes = cn(buttonSlot(), className);
    const iconSlotClasses = iconSlot();
    const wrapperSlotClasses = wrapperSlot();
    const iconSize = iconSizes[props.size || 'md'];
    const Comp = asChild ? Slot : 'a';
    return /*#__PURE__*/ jsx(Comp, {
        ref: ref,
        className: classes,
        ...cleanProps(props, Object.keys(aVariants.variants)),
        ...disabled && {
            'aria-disabled': true,
            tabIndex: -1,
            onClick: (e)=>e.preventDefault()
        },
        children: /*#__PURE__*/ jsx(Slottable, {
            children: /*#__PURE__*/ jsxs("span", {
                className: wrapperSlotClasses,
                children: [
                    iconLeft && /*#__PURE__*/ jsx(CdnIcon, {
                        className: iconSlotClasses,
                        iconName: iconLeft,
                        size: iconSize
                    }),
                    /*#__PURE__*/ jsx("span", {
                        className: textSlot(),
                        children: children
                    }),
                    iconRight && /*#__PURE__*/ jsx(CdnIcon, {
                        className: iconSlotClasses,
                        iconName: iconRight,
                        size: iconSize
                    })
                ]
            })
        })
    });
});
export { A_A as A };
